<template>
    <div class="publicPassage_wrap">
        <el-page-header style='margin-top: 40px' @back='$core.goBack'></el-page-header>
        <!-- 内容大容器 -->
        <div class="big_content">
            <!-- 图片 -->
            <div class="top_img"></div>
            <div class="content_wrap">
                <!-- 信息 -->
                <div class="passage_msg flex-between">
                    <div></div>
                    <div class="title">
                        {{codeInfo.title}}
                    </div>
                    <div>
                        <el-button  @click="downloadVisible = true" type="primary">
                            <span v-if="communityType == 1 ">下载数据</span>
                            <span v-if="communityType == 2">下载源代码</span>
                            <span v-if="communityType == 4">查看分析报告</span>
                        </el-button>
                        <el-button style="width:130px" type="primary" @click="isStartVisible = true" v-if="communityType == 2">进入实验环境</el-button>
                    </div>
                </div>
                <!-- 数据内容 -->
                <div class="source_content">
                    <!-- 数据简介 -->
                    <div>
                        <div class="icon_wrap">
                            <i class="el-icon-document" v-if="communityType == 1">&nbsp;数据简介</i>
                            <i class="el-icon-document" v-if="communityType == 2">&nbsp;源代码简介</i>
                            <i class="el-icon-document" v-if="communityType == 4">&nbsp;分析报告简介</i>
                        </div>
                        <div class="content_text">
                            {{brief}}
                        </div>
                    </div>
                    <!-- 字段描述 -->
                    <div v-if="describe.length">
                        <div class="icon_wrap">
                            <i class="el-icon-data-analysis">&nbsp;字段描述</i>
                        </div>
                        <div class="table_wrap">
                            <el-table :data="describe"  border :header-cell-style="$core.tableHeader"  stripe header-align="center" >
                                <el-table-column width="80" align="center" type="index" label="序号"></el-table-column>
                                <el-table-column align="center" prop="name" label="字段名"></el-table-column>
                                <el-table-column align="center" prop="type" label="数据类型"></el-table-column>
                                <el-table-column align="center" prop="description" label="描述"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <!-- 数据示例 -->
                    <div v-if="examples.length">
                        <div class="icon_wrap">
                            <i class="el-icon-film">&nbsp;数据示例</i>
                        </div>
                        <div class="img_array">
                            <div v-for="item in examples" :key="item.name" class="img_item">
                                <viewer>
                                    <img :src="item.imgUrl" alt="">
                                </viewer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 通过url分享资源弹框 -->
        <el-dialog :visible.sync='shareVisible' width='27%' center>
            <div class='dialog_content'>
                <div class='text'>点击复制下方链接，分享给他人</div>
                <div class='flex-start'>
                    <el-input id='copy' v-model='currentUrl'></el-input>
                    <el-button type='primary' @click='copyLink'><i class='el-icon-link'></i></el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 下载数据资源弹框 -->
        <el-dialog :visible.sync='downloadVisible' width='45%' center>
            <el-table @selection-change='selectTable' :data='downloadTable' style='width: 100%' stripe
                      class='contractTable' :header-cell-style='$core.tableHeader'>
                <el-table-column align='center' type='selection' width='55'></el-table-column>
                <el-table-column align='center' prop='name' label='文件名称'></el-table-column>
                <el-table-column align='center' prop='fileSize' label='文件大小'>
                    <template>
                        <div slot-scope='scope'>
                            {{ scope.row.fileSize / 1024 / 1024 + 'Mb' }}
                        </div>
                    </template>
                </el-table-column>
               <el-table-column align="center" prop="createTime" label="上传日期"></el-table-column>
           </el-table>
           <div class="dialog_footer">
                <el-button type="primary" @click="downloadFile">下&nbsp;&nbsp;&nbsp;载</el-button>
           </div>
        </el-dialog>
        <!-- 启动环境 -->
        <el-dialog :visible.sync='isStartVisible' width='22%' center>
            <span class='dialog_text'>是否立即启动环境？</span>
            <span slot='footer' class='dialog-footer'>
              <el-button type='primary' @click='toExperiment'>是</el-button>
              <el-button @click='isStartVisible = false'>否</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { communityDetail, publicDetail, sourceDataFile } from '../../../utils/api';

export default {
    data() {
        return {
            source: this.$route.query.source || 2,//为1时来源于数据资源公共数据，为2时来与共享社区
            isStartVisible: false,
            codeInfo: {
                title: '',
                username: '',
                userAvatar: ''
            },
            id:this.$route.query.id,
            currentUrl:window.location.href,
            shareVisible:false,
            downloadVisible:false,
            downloadTable:[],
            selectList:[],
            brief:'',
            describe:[],
            examples:[],
            communityType:1,//1为源数据，2为源代码，4为分析报告
        };
    },
    mounted(){
        this.getCodeDetail()
    },
    methods:{
        //复制链接
        copyLink(){
            let input= document.getElementById('copy')
            input.select()
            document.execCommand("copy")
            this.shareVisible = false
            this.$message.success('复制成功，快去分享给好友吧！！')
        },

        //下载文件
        downloadFile(){
            this.downloadTable.forEach(file =>{
                this.selectList.forEach(item =>{
                    if(item.id == file.id){
                        window.open(file.fileUrl)
                    }
                })
            })
            this.downloadVisible = false
        },

         //进入实验
        toExperiment(){
            this.isStartVisible = false
            window.open(`${this.$config.SYSTEM_URL}/hub`)
        },

        // 获取社区文章详情信息
        // source为1时为公共数据，否则为社区数据
        getCodeDetail(){
            let dataAPI = this.source == 1 ? publicDetail : communityDetail
            dataAPI({ id: this.id }).then(res => {
                res.data.type && (this.communityType = res.data.type);
                this.codeInfo = res.data;
                this.brief = res.data.summary;
                this.describe = JSON.parse(res.data.fieldDescription);
                res.data.sampleImage && (this.examples = JSON.parse(res.data.sampleImage));
            }).catch(err=>{})
            //获取下载文件信息
            sourceDataFile({
                fileType: this.source == 1 ? 'DATA_PUBLIC' : 'SHARED_COMMUNITY',
                dataId: this.id
            }).then(res => {
                this.downloadTable = res.data;
            }).catch(err=>{})
        },

        //选择数据
        selectTable(val){
            this.selectList = val;
        }
    }
};
</script>

<style lang="scss" scoped>

.publicPassage_wrap {
    padding-top: 5px;
    background: #fafbff;
    padding-bottom: 100px;
    .big_content {
        padding-bottom: 50px;
        background: #ffffff;
        .top_img {
            width: 100%;
            height: 300px;
            background: url('../../../assets/img/community_two.png') 0 0/100% 100% no-repeat;
        }
        .content_wrap {
            width: calc(100% - 400px);
            margin-left: 200px;

            .passage_msg {
                width: 100%;
                // height: 200px;
                // background: #69e292;
                margin-top: 40px;
                margin-bottom: 40px;
                .title {
                    font-size: 40px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    line-height: 42px;
                    color: #5277f7;
                }
                .source_log {
                    width: 44px;
                    height: 44px;
                    border: 1px solid #5277f7;
                    border-radius: 22px;
                    background: #ffffff;
                    position: relative;
                    text-align: center;
                    margin-top: 30px;
                    img {
                        width: 38px;
                        height: 8px;
                        margin-top: 20px;
                    }
                }
                .passage_source {
                    // float: right;
                    position: relative;
                    left: 60px;
                    top: -30px;
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    line-height: 20px;
                    color: #5278f7;
                }
                .psg_info {
                    width: 100%;
                    margin-top: 20px;
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    span {
                        font-size: 16px;
                        font-family: PingFang SC;
                        font-weight: 400;
                        line-height: 20px;
                        color: #3c3c3c;
                    }
                    .info_title{
                        font-weight: 600;
                    }
                    .el-button {
                        margin-top: -20px;
                        width: 200px;
                        height: 50px;
                    }
                }
                .psg_info span:nth-child(3) {
                    margin-left: 356px;
                }
            }
            .source_content{
                .icon_wrap{
                    margin: 30px 0px;
                    i{
                        font-size: 22px;
                        font-weight: bold;
                        color: #002D72;
                    }
                }
                .content_text{
                    font-size: 20px;
                    text-indent: 2rem;
                    line-height: 1.7;
                    color: #333;
                    font-weight: 400;
                }
                .img_array{
                    display: flex;
                    flex-wrap: wrap;
                    .img_item{
                        position: relative;
                        margin: 20px 20px;
                        width: 250px;
                        height: 180px;
                        border-radius: 10px;
                        box-shadow: -2px 3px 2px rgba(128,128,128,.4);
                        overflow: hidden;
                        img{
                            position: absolute;
                            transform: translate(-50%,-50%);
                            top: 50%;
                            left: 50%;
                            // max-width: 250px;
                            // overflow: hidden;
                            // max-height: 180px;
                            width: 250px;
                        }
                    }
                    .img_item:hover{
                        opacity: 0.8;
                        box-shadow: -2px 3px 2px rgba(128,128,128,.6);
                        cursor: pointer;
                    }
                }
            }

            .md_msg {
                width: 100%;
                height: 200px;
                margin-top: 30px;
                background: #fafbff;
            }
        }
    }
}
.passage_share {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #5278f7;
    position: fixed;
    top: 400px;
    right: 250px;
    text-align: center;
    i {
        line-height: 50px;
        font-size: 26px;
        color: #ffffff;
    }
}
.passage_download{
    @extend .passage_share;
    top: 330px;
    background: white;
    border: 2px solid #5278f7;
    box-sizing: border-box;
    i{
        color: #5278f7;
    }
}
.dialog_footer{
    box-sizing: border-box;
    height: 80px;
    line-height: 80px;
    text-align: center;
    margin-top: 20px;
    .el-button{
        width: 120px;
        // letter-spacing: 8px;
    }
    // padding: 0px 60px;
}
.dialog_content{
    padding: 10px 30px;

    .text{
        width: 100%;
        text-align: center;
        height: 50px;
        line-height: 50px;
        margin-bottom: 10px;
        color: #5278f7;
        font-size: 20px;
    }
    /deep/.el-input__inner{
        color: #5278F7 ;
    }
}
.passage_share:hover {
    cursor: pointer;
    box-shadow: 1px 9px 15px -5px rgba(0, 0, 0, 0.4);
    -webkit-box-shadow: 1px 9px 15px -5px rgba(0, 0, 0, 0.4);
    -moz-box-shadow: 1px 9px 15px -5px rgba(0, 0, 0, 0.4);
    transition: transform 0.4s 0.5s, black 0.4s;
}
</style>
